module.exports = __webpack_public_path__ + "img/38.aa0ce3af.png";